import VideoPlayer from './VideoPlayer';

interface IPreviewMediaProps {
  mediaUrl: string;
  isMMSVideo?: boolean,
  mediaName?: string,
}

const PreviewMedia = ({ isMMSVideo, mediaUrl, mediaName }: IPreviewMediaProps) => {
  const isVcf = mediaName?.endsWith('.vcf') || mediaUrl?.endsWith('.vcf');
  return (
    isVcf ? <div className='flex relative justify-between items-center py-2 pr-2 pl-4 w-5/6 whitespace-pre-wrap break-words bg-dark-ice rounded-large'>
      <p className='text-xs text-black'>Jane Doe</p>
      <div className='flex items-center'>
        <div className='flex justify-center items-center mr-2 w-7 h-7 bg-white rounded-full'>JD</div>
      </div>
    </div> : !isMMSVideo ? <img className='rounded-2xl' src={mediaUrl} /> : <VideoPlayer mediaUrl={mediaUrl} />
  );
};

export default PreviewMedia;